/**
 * Badge — Small status indicator
 *
 * Variants:
 *   - variant: default, success, warning, error, info, muted
 *   - size: sm, md
 *
 * Pass `variant` to both Badge and BadgeText to match colors.
 */
import { styled, XStack, Text as TamaguiText } from 'tamagui'

export const Badge = styled(XStack, {
  name: 'Badge',
  ai: 'center',
  jc: 'center',
  br: '$full',
  px: 10,
  py: 5,
  bg: '$colorPrimary',

  variants: {
    variant: {
      default: { bg: '$colorPrimary' },
      success: { bg: '$colorSuccess' },
      warning: { bg: '$colorWarning' },
      error: { bg: '$colorError' },
      info: { bg: '$colorInfo' },
      muted: { bg: '$backgroundSecondary' },
    },

    size: {
      sm: { px: 8, py: 3 },
      md: { px: 10, py: 5 },
    },
  } as const,

  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
})

export const BadgeText = styled(TamaguiText, {
  name: 'BadgeText',
  fontFamily: '$body',
  fontSize: 12,
  fontWeight: '700',
  color: '$colorInverse',

  variants: {
    variant: {
      default: { color: '$colorInverse' },
      success: { color: '$colorInverse' },
      warning: { color: '$colorInverse' },
      error: { color: '$colorInverse' },
      info: { color: '$colorInverse' },
      muted: { color: '$colorSecondary' },
    },

    size: {
      sm: { fontSize: 10 },
      md: { fontSize: 12 },
    },
  } as const,

  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
})
